// extracted by mini-css-extract-plugin
export default {"navLink":"NavBar_navLink__X5eUh","colorNavLink":"NavBar_colorNavLink__QypEi"};